<template>
  <header class="header">
    <div
      class="header__wrapper"
      v-if="attendee.conference?.name || attendee.conference?.date"
    >

      <div class="header__left">

        <time-zone-view
          :title="attendee.conference?.name"
          :description="`${attendee.conference?.date} | ${attendee?.timezone_name}`"
        />
      </div>


      <div class="header__right">
        <button class="header-filter-desktop" @click="openFilterMobile" v-if="attendee.enable_session_filtering && eventListPage">
          <div class="header-filter-desktop__notify" v-if="filtersUsed">
            {{ filtersUsed }}
          </div>
          <i class="fa-solid fa-magnifying-glass"></i>
        </button>
        <DropDownMenu position="center">
          <div class="header__profile">
            <div>


              <img
                v-if="attendee.profile_image_url"
                :src="attendee.profile_image_url"
                alt="User Photo"
                width="35"
              />

              <div v-else class="avatar-no-photo">
                <i class="fa-regular fa-user"></i>
              </div>

              <div class="profile__name">{{ attendee.name }}</div>
            </div>
          </div>
        </DropDownMenu>
      </div>

    </div>
  </header>
</template>

<script>
import {mapGetters} from "vuex";
import Container from "../../ui/Container";
import Burger from "../../ui/Burger";
import CommonMenu from "../CommonMenu";
import TimeZoneView from "./TimeZoneView";
import {resetAuthHeadersAndLocalStore} from "../../../api";
import {ROUTES} from "../../../router";
import DropDownMenu from "../DropDownMenu";

export default {
  components: {
    Container,
    Burger,
    CommonMenu,
    TimeZoneView,
    DropDownMenu,
  },
  data() {
    return {
      homePageLink: ROUTES.MAIN_LAYOUT.replace(':attendeeId', this.$route.params.attendeeId),
      isOpen: false,
      isAuthMenuOpen: false,
      attendeeId: this.$route.params.attendeeId,
    };
  },
  computed: {
    ...mapGetters("attendeeStore", ["attendee", "showUpgradeTicketMenu"]),
    ...mapGetters('agendaStore', [
      'filtersUsed',
    ]),
    eventListPage(){
      return ROUTES.AGENDA_EVENT.replace(':attendeeId', this.$route.params.attendeeId) === this.$route.path;
    }
  },
  methods:{
    openFilterMobile() {
      this.$store.dispatch("agendaStore/openFilterMobile");
    },

    closeFilterMobile() {
      this.$store.dispatch("agendaStore/closeFilterMobile");
    },
  }
};
</script>

<style lang="scss" scoped>

.header {
  background-color: var(--attendee-header-background-color);
  width: 100%;
  box-shadow: var(--attendee-box-shadow);
  border-radius: var(--attendee-card-border-radius);

  &__right{

    display: flex;
    align-items: center;
    gap: var(--attendee-gap-md);
  }

  .header-filter-desktop{
    font-size: 20px;
    position: relative;
    background-color: rgba(0,0,0,0);
    border: none;
    outline: none;
    box-shadow: none;

    @media (min-width: 1100px) {
      display: none;
    }

    &__notify{
      position: absolute;
      top: -5px;
      right: -5px;
      background-color: rgb(255, 102, 102);
      font-size: 12px;
      height: 15px;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 15px;
      border-radius: 15px;
      padding: 0 4px;
    }
  }

  &__left {
  }

  &__wrapper {
    padding: 0 var(--attendee-gap-md);
    height: var(--attendee-header-height);
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: var(--attendee-container-width);
    margin: 0 auto;
  }

  &__profile {
    position: relative;
    cursor: pointer;

    .avatar-no-photo {
      width: 35px;
      height: 35px;
      min-width: 35px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--attendee-brand-color);

      svg {
        color: white;
        font-size: 18px;
      }
    }

    &:hover {

      .profile__name {
        color: var(--attendee-brand-color);
      }

    }

    > div {
      display: flex;
      align-items: center;
      gap: 10px;
      text-decoration: none;

      .profile__name {
        transition: .3s all;
        font-size: 16px;
        font-weight: 600;
        color: var(--attendee-text-primary-color);
      }
    }

    img {
      border-radius: 50%;
      width: 35px;
      height: 35px;
      object-fit: cover;
      object-position: center;
    }
  }
}
</style>
